export const RPC_LATENCY_INTERVAL_MS = 15000
export const RPC_LATENCY_TIMEOUT_MS = 5000

function withTimeout(promise, timeoutMs) {
    return new Promise((resolve, reject) => {
        const timer = setTimeout(() => reject(new Error(`RPC latency timeout after ${timeoutMs}ms`)), timeoutMs)

        Promise.resolve(promise).then((value) => {
            clearTimeout(timer)
            resolve(value)
        }, (error) => {
            clearTimeout(timer)
            reject(error)
        })
    })
}

export async function measureRpcLatency(provider, {
    timeoutMs = RPC_LATENCY_TIMEOUT_MS,
    now = Date.now,
} = {}) {
    if (!provider || typeof provider.send !== 'function') {
        throw new Error('RPC provider is unavailable')
    }

    const startedAt = now()
    await withTimeout(provider.send('eth_blockNumber', []), timeoutMs)
    return Math.max(0, Math.round(now() - startedAt))
}
